module.exports = __webpack_public_path__ + "img/assign_2_active.8a3510ef.png";